import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PivotItem } from "@fluentui/react/lib/Pivot";

import { projectsFilterKeySet } from "Store/Actions";
import { selectFilterKey } from "Store/Selectors/Filter";
import { IUseFilter } from "./IUseFilter";

export function useFilter(): IUseFilter {
  const selectedKey = useSelector(selectFilterKey);
  const dispatch = useDispatch();

  const onFilterClick = useCallback(
    (item: PivotItem) => {
      dispatch(projectsFilterKeySet(item.props.itemKey));
    },
    [dispatch]
  );

  return {
    selectedKey,
    onFilterClick
  };
}
